import { render, staticRenderFns } from "./AppLoadingScreen.vue?vue&type=template&id=72cda50e&scoped=true"
import script from "./AppLoadingScreen.vue?vue&type=script&lang=js"
export * from "./AppLoadingScreen.vue?vue&type=script&lang=js"
import style0 from "./AppLoadingScreen.vue?vue&type=style&index=0&id=72cda50e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cda50e",
  null
  
)

export default component.exports